import React from "react";
import { useLandingLang } from "../../i18n/LandingLangContext";

// --- Iconos SVG Inline ---

function ArrowRightIcon({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M5 12h14" />
      <path d="m12 5 7 7-7 7" />
    </svg>
  );
}

function ShieldCheckIcon({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  );
}

function ImageIcon({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <circle cx="9" cy="9" r="2" />
      <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
    </svg>
  );
}

// --- Componente Hero ---

export function Hero({ heroImageSrc, onOpenDemo }) {
  const { t } = useLandingLang();
  return (
    <section
      id="top"
      className="relative pt-24 lg:pt-36 pb-12 px-6 overflow-hidden bg-white text-slate-700 text-center lg:text-left"
    >
      {/* Blob decorativo */}
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-[500px] h-[500px] bg-sky-100/40 rounded-full blur-[100px] -z-10"></div>

      <div className="max-w-7xl mx-auto grid lg:grid-cols-[45%_55%] gap-12 lg:gap-20 items-center">
        {/* Columna Izquierda */}
        <div className="space-y-8">
          <div className="inline-flex items-center gap-3 bg-white border border-sky-100 shadow-sm px-4 py-2 rounded-2xl text-[11px]">
            <span className="flex h-2 w-2 rounded-full bg-sky-400 animate-pulse"></span>
            <span className="text-[11px] !font-bold text-sky-500 uppercase tracking-widest">
              {t("techTag")}
            </span>
          </div>

          {/* TÍTULO PRINCIPAL */}
          <h1 className="text-4xl lg:text-5xl !font-black leading-tight tracking-tight text-slate-900 mb-0">
            {t("heroTitle1")} <br />
            {/* CORRECCIÓN AQUÍ:
                Añadido 'pr-2' (padding-right) para evitar que la cursiva se corte
            */}
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-sky-400 to-blue-600 italic pr-2">
              {t("heroTitle2")}
            </span>
          </h1>

          <p className="text-lg text-slate-500 max-w-lg leading-relaxed font-medium mx-auto lg:mx-0">
            {t("heroDesc")}
          </p>

          <div className="flex flex-wrap justify-center lg:justify-start gap-4">
            <button
              type="button"
              onClick={onOpenDemo}
              className="px-10 py-4 bg-gradient-to-r from-sky-400 to-blue-500 text-white rounded-[2rem] !font-bold shadow-xl shadow-sky-100 hover:scale-105 transition-all flex items-center gap-3 uppercase tracking-widest text-xs text-center border-0 cursor-pointer"
            >
              {t("requestInfo")}{" "}
              <ArrowRightIcon className="w-[18px] h-[18px]" />
            </button>
          </div>
        </div>

        {/* Columna Derecha */}
        <div className="relative group">
          <div className="bg-gradient-to-br from-sky-100 to-white p-3 rounded-[2.5rem] shadow-2xl border border-white overflow-hidden transform lg:scale-105 transition-transform duration-700">
            <div className="bg-white rounded-[2rem] overflow-hidden aspect-video flex items-center justify-center relative">
              {heroImageSrc ? (
                <img
                  src={heroImageSrc}
                  alt="Sesión REVI"
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                  loading="eager"
                />
              ) : (
                <ImageIcon className="w-16 h-16 text-sky-200" />
              )}
            </div>
          </div>

          <div className="absolute -bottom-10 -left-6 bg-white/70 backdrop-blur-md p-5 rounded-3xl shadow-xl border border-white/50 flex items-center gap-4 max-w-[240px] z-10 hover:bg-white/90 transition-all duration-500">
            <div className="w-10 h-10 bg-emerald-50 text-emerald-500 rounded-xl flex items-center justify-center shrink-0 shadow-sm">
              <ShieldCheckIcon className="w-6 h-6" />
            </div>
            <p className="text-[11px] !font-bold text-slate-700 leading-tight text-left">
              {t("heroCert")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
